import { ref, watch } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import ReportOptions from '@/views/reports/components/options.js'
import { h } from 'preact'

const { defaultFromdate, defaultTodate } = ReportOptions()
export default function TotalAbsencePerMonthReportLogic() {

  const request = ref({
    page: 1,
    length: 25,
    type: 'totalAbsencePerMonth',
    month: "",
    contracts: [],
    conditions:[],
    
   // conditions: ["hours < 3600000", "distance < 1000"]


  })

  //////////  conditons ////////
  const hoursOperator=ref("")
  const hours = ref(0)

  const distanceOperator=ref("")
  const distance=ref(0)
  const campLeave=ref(0)



  //////////end ////////

  const date = ref('')

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading = ref(false)


  const getReport = () => {
    errors.value = {}
    loading.value = true
    request.value.conditions=[]

   
    if(hoursOperator.value!=""){
      request.value.conditions.push('hours '+hoursOperator.value+' '+hours.value*3600000)
    }
    

    if(distanceOperator.value!=""){
      request.value.conditions.push('distance '+distanceOperator.value+' '+distance.value*1000)
    }


     request.value.conditions.map((c,index)=>{
      if(c.includes('null')){       
        request.value.conditions.splice(index,1)
      }
 
     })
     if(campLeave.value==1){
      request.value.conditions.push('campLeave = '+campLeave.value)
     }
    ReportService.getReport(request.value)
      .then(res => {
       
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => loading.value = false)
  }


  const sortBy = ref('id')
  const isSortDirDesc = ref(true)


  watch([sortBy, isSortDirDesc], () => {
    request.value.sortBy = isSortDirDesc.value == true ? sortBy.value + ',desc' : sortBy.value + ',asc';
    dataTableloading.value = true

    ReportService.getReport(request.value)
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => dataTableloading.value = false)
  })


  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.getReport({
        ...Object.assign(request.value, {
          page: 1
        }), length: 50000
      }).then(res => r(res.data.data))
        .finally(() => loading.value = false)
    })
  }


  return {
    getReport, getReportForPdf,
    report_data,
    total, from, to,
    request, date,
    loading,
    errors,
    isSortDirDesc, sortBy, dataTableloading,

    hoursOperator,
     hours, 

    distanceOperator,
     distance,
     campLeave,


  }
}
